import styled from 'styled-components';
import { Hint } from './Tags';

const Wrapper = styled.div`
  margin-bottom: 12px;
  width: 100%;
`;

const Label = styled.label`
  color: #383838;
  display: block;
`;

const ErrorDiv = styled.p`
  color: red;
  font-size: 11px;
`;

const Required = styled.span`
  color: red;
`;

const FormItem = ({ label, error, required, children, hint = '' }) => (
  <Wrapper>
    <Label>
      {label}
      {required && <Required>*</Required>}
      {hint && <Hint hint={hint} color={'#757575'} />}
    </Label>
    {children}
    <ErrorDiv>{error}</ErrorDiv>
  </Wrapper>
);

export default FormItem;